import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  InputBase,
  IconButton,
  Chip,
  Divider,
  Card,
  CardHeader,
  CardContent,
  Grid,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";

const VendorQuotation = () => {
  // Sample data for quotations
  const quotations = [
    {
      id: "QT-2024-0001",
      rfqId: "RFQ-2024-0101",
      amount: "844202.23",
      validUntil: "Apr 11, 2024",
      status: "Submitted",
      items: 2,
      leadTime: "15 days",
    },
    {
      id: "QT-2024-0002",
      rfqId: "RFQ-2024-0102",
      amount: "819629.29",
      validUntil: "Apr 12, 2024",
      status: "Accepted",
      items: 4,
      leadTime: "30 days",
    },
    {
      id: "QT-2024-0003",
      rfqId: "RFQ-2024-0103",
      amount: "771720.20",
      validUntil: "Apr 13, 2024",
      status: "Pending Review",
      items: 5,
      leadTime: "12 days",
    },
    {
      id: "QT-2024-0004",
      rfqId: "RFQ-2024-0104",
      amount: "351602.02",
      validUntil: "Apr 14, 2024",
      status: "Accepted",
      items: 9,
      leadTime: "7 days",
    },
    {
      id: "QT-2024-0005",
      rfqId: "RFQ-2024-0105",
      amount: "320202.02",
      validUntil: "Apr 15, 2024",
      status: "Submitted",
      items: 1,
      leadTime: "25 days",
    },
    {
      id: "QT-2024-0006",
      rfqId: "RFQ-2024-0106",
      amount: "111900.69",
      validUntil: "Apr 16, 2024",
      status: "Pending Review",
      items: 4,
      leadTime: "9 days",
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Submitted":
        return { bg: "#E0E7FF", color: "#4F46E5" };
      case "Accepted":
        return { bg: "#DCFCE7", color: "#10B981" };
      case "Pending Review":
        return { bg: "#FEF3C7", color: "#F59E0B" };
      default:
        return { bg: "#F3F4F6", color: "#6B7280" };
    }
  };

  return (
    <div className="page-container">
      <Card
        className="shadow-sm"
        variant="outlined"
        sx={{
          border: "1px solid lightgray",
          borderRadius: "10px",
          width: "100%",
        }}
      >
        <CardHeader
          title={<Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px', color: '#333' }} className="font-rubik">Quotations</Typography>}
          action={
            <div>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{
                  marginRight: "8px",
                  backgroundColor: "#050092",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#050092" },
                  fontWeight: 400,

                }}
                className="font-rubik"
              >
                New Quotation
              </Button>
            </div>
          }
          sx={{
            margin: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        />
        <Divider sx={{ backgroundColor: "darkgray" }} />

        <CardContent>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 2 }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}
            >
              <Paper
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: 250,
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  boxShadow: "none",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search quotations..."
                  inputProps={{ "aria-label": "search quotations" }}
                />
                <IconButton
                  type="submit"
                  sx={{ p: "10px" }}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
              </Paper>

              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                sx={{
                  borderColor: "#e0e0e0",
                  color: "#6B7280",
                  textTransform: "none",
                  borderRadius: "8px",
                }}
              >
                Filter
              </Button>
            </Box>

            {/* <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                bgcolor: "#050092",
                "&:hover": { bgcolor: "#050092" },
                borderRadius: "8px",
                textTransform: "none",
                display: { xs: "none", sm: "flex" },
              }}
            >
              New Quotation
            </Button> */}
          </Box>

          <Grid container spacing={3}>
            {quotations.map((quotation) => {
              const statusStyle = getStatusColor(quotation.status);
              return (
                <Grid item xs={12} sm={6} md={4} key={quotation.id}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      borderRadius: "8px",
                      height: "100%",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                      border: "1px solid #f0f0f0",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 2,
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "medium", color: "#111827", fontFamily: 'Rubik' }}
                      >
                        {quotation.id}
                      </Typography>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <IconButton
                          size="small"
                          sx={{ color: "#6B7280", padding: "2px" }}
                        >
                          <FileDownloadIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          sx={{ color: "#6B7280", padding: "2px" }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>

                    <Typography
                      variant="body2"
                      sx={{ color: "#6B7280", mb: 2 }}
                    >
                      For {quotation.rfqId}
                    </Typography>

                    <Typography
                      sx={{ fontWeight: "bold", color: "#111827", my: 2, fontSize:"22px" }} className="font-montserrat"
                    >
                      {quotation.amount}
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Box
                        component="span"
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          mr: 1,
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            backgroundColor: "#E0E7FF",
                            mr: 0.5,
                          }}
                        />
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{ color: "#6B7280", fontFamily: 'Rubik' }}
                      >
                        Valid until {quotation.validUntil}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2,
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: "medium", fontFamily: 'Rubik' }}>
                        Status
                      </Typography>
                      <Chip
                        label={quotation.status}
                        sx={{
                          bgcolor: statusStyle.bg,
                          color: statusStyle.color,
                          fontWeight: "medium",
                          borderRadius: "16px",
                          fontSize: "0.75rem",
                          height: "24px",
                        }}
                      />
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography variant="body2" sx={{ color: "#6B7280", fontFamily: 'Rubik' }}>
                        Items
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "medium", color: "#111827", fontFamily: 'Rubik' }}
                      >
                        {quotation.items} items
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="body2" sx={{ color: "#6B7280", fontFamily: 'Rubik' }}>
                        Lead Time
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "medium", color: "#111827", fontFamily: 'Rubik' }}
                      >
                        {quotation.leadTime}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default VendorQuotation;
